module.exports = __webpack_public_path__ + "img/logo_konkatsu01.f6c3dfae.png";